import { NgModule } from '@angular/core';

import { ReportRoutingModule } from './report.routing';
import { ListReportComponent } from './list-report/list-report.component';
import { AutomakerSelectModalComponent } from './automaker-select-modal/automaker-select-modal.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [ListReportComponent, AutomakerSelectModalComponent],
  imports: [SharedModule, ReportRoutingModule]
})
export class ReportModule {}
